<template>
  <div class="ncnp-callback">
    <div class="callback-panel">
      <i :class="iconClass"></i>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
// state 防重放 + redirect 白名单：仅放行站内路径（最新方案下无外链订购流程）
const NCNP_STATE_KEY = "ncnpAuthState";
const NCNP_RETURN_KEY = "ncnpReturnAfterLogin";
// 兼容旧键：早期把外链 accessUrl 写入 ncnpRedirectAfterLogin，迁移期内读取后清掉
const LEGACY_REDIRECT_KEY = "ncnpRedirectAfterLogin";
const SAFE_REDIRECT_PATHS = ["/compute", "/infra", "/orders", "/goods", "/user", "/ncnp", "/console"];

function isSafeRedirect(target) {
  if (typeof target !== "string" || target.length === 0) return false;
  // 一律拒绝绝对 URL / 协议相对 URL（最新方案下订购流程已不存在跳外链场景）
  if (/^https?:\/\//i.test(target)) return false;
  if (target.startsWith("//")) return false;
  if (!target.startsWith("/")) return false;
  return SAFE_REDIRECT_PATHS.some(
    (p) => target === p || target.startsWith(`${p}/`) || target.startsWith(`${p}?`)
  );
}

export default {
  name: "NcnpCallback",
  data() {
    return {
      message: "正在完成登录",
      status: "loading",
    };
  },
  computed: {
    iconClass() {
      if (this.status === "success") return "el-icon-circle-check";
      if (this.status === "error") return "el-icon-circle-close";
      return "el-icon-loading";
    },
  },
  async created() {
    const { code, state, redirect, task_id: taskId, order_id: orderId, channel_order_id: channelOrderId } = this.$route.query;
    if (!code) {
      this.status = "error";
      this.message = "缺少授权码";
      return;
    }
    const storedState = localStorage.getItem(NCNP_STATE_KEY);
    if (storedState && state && storedState !== state) {
      this.status = "error";
      this.message = "state 校验失败";
      return;
    }
    try {
      const data = await this.$store.dispatch("user/ncnpLogin", { code, state });
      localStorage.removeItem(NCNP_STATE_KEY);
      this.status = "success";
      this.message = "登录成功";

      // 优先级：后端 redirectAfterLogin > URL query redirect > 本地缓存 > 兼容旧键
      let target =
        data.redirectAfterLogin ||
        redirect ||
        localStorage.getItem(NCNP_RETURN_KEY) ||
        localStorage.getItem(LEGACY_REDIRECT_KEY) ||
        "/compute";
      localStorage.removeItem(NCNP_RETURN_KEY);
      localStorage.removeItem(LEGACY_REDIRECT_KEY);

      // welcome task_id=pay 短路：直接到支付页
      if (taskId === "pay" && (orderId || channelOrderId)) {
        const params = new URLSearchParams();
        if (orderId) params.append("order_id", orderId);
        if (channelOrderId) params.append("channel_order_id", channelOrderId);
        target = `/orders/pay?${params.toString()}`;
      }

      if (!isSafeRedirect(target)) {
        target = "/compute";
      }
      setTimeout(() => {
        this.$router.replace(target);
      }, 300);
    } catch (error) {
      localStorage.removeItem(NCNP_STATE_KEY);
      this.status = "error";
      this.message = "登录失败";
    }
  },
};
</script>

<style scoped lang="scss">
.ncnp-callback {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
}

.callback-panel {
  min-width: 240px;
  padding: 32px;
  text-align: center;
  color: #303133;

  i {
    display: block;
    font-size: 36px;
    color: #1677ff;
    margin-bottom: 16px;
  }

  .el-icon-circle-close {
    color: #f56c6c;
  }

  p {
    margin: 0;
    font-size: 16px;
  }
}
</style>
